import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
interface LegalLayoutProps {
  title: string;
  children: React.ReactNode;
}
export const LegalLayout = ({
  title,
  children
}: LegalLayoutProps) => {
  return <div className="min-h-screen bg-dark text-gray-300 font-sans flex flex-col" data-id="element-373">
      {/* Header */}
      <header className="border-b border-white/10 bg-[#0a0a0a]" data-id="element-374">
        <div className="container mx-auto px-4 py-5 flex items-center justify-between max-w-4xl" data-id="element-375">
          <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-[#ADFF2F] transition-colors text-sm font-medium" data-id="element-376">
            <ArrowLeft className="w-4 h-4" data-id="element-377" />
            Volver al inicio
          </Link>
          <span className="text-[#ADFF2F] font-bold text-sm tracking-widest uppercase" data-id="element-378">
            Efectivo Inmediato
          </span>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 py-16 md:py-20" data-id="element-379">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-380">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-10 leading-tight" data-id="element-381">
            {title}
          </h1>

          <div className="bg-[#111111] border border-white/10 rounded-2xl p-8 md:p-10 prose prose-invert max-w-none" data-id="element-382">
            {children}
          </div>

          <p className="text-gray-500 text-sm mt-8 font-sans" data-id="element-383">
            Última actualización: Mayo 2026
          </p>
        </div>
      </main>

      <Footer data-id="element-384" />
    </div>;
};